import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// One route only — a property opens in a drawer over the queue, deep-linked
// via `?propertyId=`, so there is no separate detail path.
export const rentLedgerRoutes: RouteRecordRaw[] = [
  {
    path: routes.RENTAL_DISTRIBUTION_LEDGER,
    name: 'RENTAL_DISTRIBUTION_LEDGER',
    component: () => import('./RentLedgerPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'view_properties',
      activeMenu: 'Rental Distribution',
    },
  },
]
